import { render, staticRenderFns } from "./CommentNotification.vue?vue&type=template&id=671243dc&scoped=true"
import script from "./CommentNotification.vue?vue&type=script&lang=js"
export * from "./CommentNotification.vue?vue&type=script&lang=js"
import style0 from "./CommentNotification.vue?vue&type=style&index=0&id=671243dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671243dc",
  null
  
)

export default component.exports